import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import whiteRingLogo from "../images/DocentToad_Logo_white-ring.svg"

function Footer() {
    return(
      <footer className="h-54 bg-gradient-to-tr from-black to-gray-700 text-white flex flex-row justify-end divide-x-2 space-x-8 py-2">
        
        <ul className="font-dokdo list-none p-2">

            <li className="text-5xl">About</li>
            <div className="text-xl">
              <li><Link to='/' className="hover:text-purple-200 cursor-pointer transition ease-in">Who am I?</Link></li>
              <li><Link to='/' className="hover:text-purple-200 cursor-pointer transition ease-in">Where am I?</Link></li>
              <li><Link to='/' className="hover:text-purple-200 cursor-pointer transition ease-in">Why am I?</Link></li>
            </div>
        </ul>
        <div className="px-8">
          <img 
            src={whiteRingLogo}
            width={120}
          />
          <nav className="space-x-4">
           <Link to="https://www.youtube.com/user/DocentToad" target="blank">
            <StaticImage
              src="../images/YT_logo_yellow.png"
              width={29}
            />
          </Link>
          <Link to="https://twitter.com/DocentToad" target="blank">
            <StaticImage
              src="../images/Twitter_logo_yellow.png"
              width={27}
            />
          </Link>
          <Link to="https://www.instagram.com/docenttoad" target="blank">
            <StaticImage
              src="../images/IG_logo_yellow.png"
              width={20}
            />
          </Link>
          </nav>
        </div>
     
      </footer>
    )
  }

  export default Footer